import * as z from 'zod';

import { fileQuerySchema } from '@/_schemas/file';
import { statusQuerySchema } from '@/_schemas/status-input';

export const systemUserQueryLinkerSchema = z.object({
  id: z.number(),
  name: z.string().nullable(),
  first_name: z.string(),
  last_name: z.string(),
  email: z.string().nullable(),
  username: z.string().nullable(),
  status: statusQuerySchema,
  profile_images: z.array(fileQuerySchema).nullish(),
});

export type SystemUserQueryLinkerSchema = z.infer<typeof systemUserQueryLinkerSchema>;
